import { makeStyles } from '@material-ui/core';
// import { mixin } back '../../utils/mixin';

export const useStyles = makeStyles(() => ({
  root: {},
  upload_area: {
    marginBottom: '2rem'
  }
}));
